import Marquee from "react-fast-marquee";
import { Star, ArrowRight } from "lucide-react";
import { Reveal, SectionTag } from "./motion";
import { DEPOIMENTOS, wa } from "../lib/site";

const Stars = () => (
  <div className="flex gap-1" aria-label="Avaliação 5 de 5 estrelas">
    {Array.from({ length: 5 }).map((_, i) => (
      <Star key={i} size={14} className="fill-amber-400 text-amber-400" />
    ))}
  </div>
);

export default function Depoimentos() {
  return (
    <section id="depoimentos" className="py-24 md:py-32 bg-white overflow-hidden" data-testid="depoimentos-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12 mb-14 flex flex-col md:flex-row md:items-end md:justify-between gap-6">
        <Reveal>
          <SectionTag>Depoimentos</SectionTag>
          <h2 className="mt-5 font-display font-extrabold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-brand-deep text-balance">
            Quem viajou comigo, <span className="font-serif italic font-medium text-brand-light">recomenda</span>
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <a
            href={wa("Olá, Magnus! Vi os depoimentos no site e quero saber mais sobre os passeios.")}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="depoimentos-cta-button"
            className="group inline-flex items-center gap-2 rounded-full border border-brand/20 px-7 py-3.5 text-sm font-bold text-brand transition-colors duration-300 hover:bg-brand hover:text-white"
          >
            Quero viajar também
            <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
          </a>
        </Reveal>
      </div>

      <Reveal>
        <div className="max-w-7xl mx-auto px-6 md:px-12 mb-14">
          <div className="group relative overflow-hidden rounded-3xl" data-testid="depoimentos-foto-grupo">
            <img
              src="https://customer-assets-7cd3h4nn.emergentagent.net/job_cataratas-experienza/artifacts/a0b3nyj3_WhatsApp%20Image%202026-09-11%20at%2009.12.39.jpeg"
              alt="Grupo de clientes com o guia Magnus na Sprinter em Foz do Iguaçu"
              loading="lazy"
              className="w-full max-h-[520px] object-cover transition-transform duration-700 ease-out group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-brand-deep/70 via-transparent to-transparent" />
            <div className="absolute bottom-6 left-6 right-6 flex flex-wrap items-end justify-between gap-4">
              <div className="text-white">
                <Stars />
                <p className="mt-2 font-display font-bold text-lg md:text-xl">Grupos reais, viagens inesquecíveis</p>
                <p className="text-white/75 text-sm">Excursão com a Sprinter pela Tríplice Fronteira</p>
              </div>
            </div>
          </div>
        </div>
      </Reveal>

      <Reveal>
        <Marquee speed={32} gradient gradientColor="#ffffff" gradientWidth={80} pauseOnHover>
          {DEPOIMENTOS.map((d, i) => (
            <figure
              key={d.name}
              data-testid={`depoimento-card-${i}`}
              className="mx-3 w-[320px] md:w-[380px] rounded-3xl border border-brand/10 bg-sand p-8"
            >
              <Stars />
              <blockquote className="mt-5 text-ink text-sm md:text-base leading-relaxed">
                “{d.text}”
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3">
                <span className="grid place-items-center w-10 h-10 rounded-full bg-brand/10 text-brand font-display font-bold text-sm">
                  {d.name.charAt(0)}
                </span>
                <div>
                  <p className="text-sm font-bold text-brand-deep">{d.name}</p>
                  <p className="text-xs text-moss">{d.from}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </Marquee>
      </Reveal>
    </section>
  );
}
